import { useScriptTag } from '@vueuse/core';
import { useHostEnv } from '.';
import { HostEnv } from '@shared/types';

export interface WxJsSdkOptions {
  qywxJsSdkUrl?: string;
  qywxJsSdkWithAgentConfigUrl?: string;
  wxJsSdkUrl?: string;
  onLoaded?: (el: HTMLScriptElement, el2?: HTMLScriptElement) => void;
}

// 根据运行环境引入微信 JSSDK（包括企业微信）
export const useWxJsSdk = (options: WxJsSdkOptions = {}) => {
  const { currentHostEnv } = useHostEnv();

  const {
    qywxJsSdkUrl = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js',
    //qywxJsSdkWithAgentConfigUrl = 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js',
    qywxJsSdkWithAgentConfigUrl = 'https://res.wx.qq.com/wwopen/js/jsapi/jweixin-1.0.0.js',
    wxJsSdkUrl = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js',
    onLoaded,
  } = options;

  const isSupported = currentHostEnv !== HostEnv.OTHER;

  if (currentHostEnv === HostEnv.WX) {
    useScriptTag(
      wxJsSdkUrl,
      (el: HTMLScriptElement) => {
        onLoaded && onLoaded(el);
      },
      {}
    );
  }
  if (currentHostEnv === HostEnv.QYWX) {
    useScriptTag(
      qywxJsSdkWithAgentConfigUrl,
      (el: HTMLScriptElement) => {
        onLoaded && onLoaded(el);
      },
      {}
    );
  }

  return {
    isSupported,
  };
};
